import { useRef } from "react";

const useCamera = () => {
    const videoRef = useRef<HTMLVideoElement | null>(null);
    const canvasRef = useRef<HTMLCanvasElement | null>(null);

    const startCamera = () => {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            console.error("Camera API is not supported in this browser.");
            alert("Camera API is not supported in this browser.");
            return;
        }

        if (videoRef.current && videoRef.current.srcObject) {
            // Stop the current stream if it exists
            const stream = videoRef.current.srcObject as MediaStream;
            const tracks = stream.getTracks();
            tracks.forEach((track) => track.stop());
            videoRef.current.srcObject = null;
        }

        navigator.mediaDevices
            .getUserMedia({ video: true })
            .then((stream) => {
                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                    videoRef.current.play().catch((error) => {
                        console.error("Error playing video", error);
                    });
                }
            })
            .catch((error) => {
                console.error("Error accessing the camera", error);
            });
    };

    const stopCamera = () => {
        if (videoRef.current && videoRef.current.srcObject) {
            const stream = videoRef.current.srcObject as MediaStream;
            const tracks = stream.getTracks();
            tracks.forEach((track) => track.stop());
            videoRef.current.srcObject = null;
        }
    };

    const captureImage = (): string | null => {
        if (videoRef.current && canvasRef.current) {
            const context = canvasRef.current.getContext("2d");
            if (context) {
                context.drawImage(videoRef.current, 0, 0, canvasRef.current.width, canvasRef.current.height);
                return canvasRef.current.toDataURL("image/png");
            }
        }
        return null;
    };

    return { videoRef, canvasRef, startCamera, stopCamera, captureImage };
};

export default useCamera;